import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UnderMaintenanceInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 503 && error.error.message === 'Cintra Cloud is currently undergoing essential maintenance') {
          this.router.navigateByUrl('/under-maintenance').then();
          return EMPTY;
        }
        return throwError(() => error);
      })
    ) as Observable<HttpEvent<any>>;
  }
}
